import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { RESUME_DOWNLOAD_NAME, RESUME_PAGE, RESUME_PATH } from '../data/site';
import '../styles/Navbar.css';

const NAV_LINKS = [
  { to: '/projects', label: 'Work' },
  { to: RESUME_PAGE, label: 'Experience' },
  { to: '/contact', label: 'Contact' },
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    setIsOpen(false);
  }, [pathname]);

  return (
    <header className="site-nav">
      <nav className="site-nav-inner container" aria-label="Main">
        <Link to="/" className="site-nav-name">
          Maurice Sanders
        </Link>

        <button
          type="button"
          className="site-nav-toggle"
          aria-controls="site-nav-menu"
          aria-expanded={isOpen}
          onClick={() => setIsOpen((open) => !open)}
        >
          <span className="visually-hidden">{isOpen ? 'Close menu' : 'Open menu'}</span>
          <span className="site-nav-toggle-bar" aria-hidden="true"></span>
          <span className="site-nav-toggle-bar" aria-hidden="true"></span>
        </button>

        <ul id="site-nav-menu" className={`site-nav-menu${isOpen ? ' is-open' : ''}`}>
          {NAV_LINKS.map(({ to, label }) => {
            const active = pathname.startsWith(to);
            return (
              <li key={to}>
                <Link to={to} className="site-nav-link" aria-current={active ? 'page' : undefined}>
                  {label}
                </Link>
              </li>
            );
          })}
          <li>
            <a href={RESUME_PATH} download={RESUME_DOWNLOAD_NAME} className="site-nav-resume">
              Resume
            </a>
          </li>
        </ul>
      </nav>
    </header>
  );
};

export default Navbar;
